import React from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery'
import Lang from '../../lang'
import queryString from 'query-string'
class WizardLeft extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            sel_nev: this.props.sel_nev,
            instalaçõesinsert: [
                "Dadosgerais",
                "tipo_instalacao",
                // "Entreposto",
                "Contatos",
                "Atividades",
                "Local",
                "Vasilhas"
            ]
        }
    }
    componentDidUpdate(preProp) {
        if (preProp.date !== this.props.date) {
            this.setState({
                sel_nev: this.props.sel_nev
            }
            )
        }
    }

    updatesel_nev = (sel_nev) => {
        this.props.updatesel_nev(sel_nev);
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        $(window).scroll(function() {
            if ($(this).scrollTop() > 65) {
                $('.left-section').addClass('fixed_left');
            } else {
                $('.left-section').removeClass('fixed_left');
            }
        });
        const parsed = queryString.parse(window.location.search)
        if(parsed.idInstalacao) {
            let instalaçõesinsert = [...this.state.instalaçõesinsert]
            instalaçõesinsert.splice(5, 0, "Capacidade");
            this.setState({
                instalaçõesinsert
            })
        }
    }

    render() {
        return (
            <div className="left-section" id="Scrollspy-custom">
                {
                    this.props.type === "parcelas" &&
                    <ul className="list-unstyled">
                        <li onClick={ () => this.updatesel_nev('parcel') }><a className={ `cursor-pointer nav-link ${this.state.sel_nev === 'parcel' ? "active" : ""}` } href="#parcel" >Parcela</a></li>
                        <li onClick={ () => this.updatesel_nev('parcelPointFactors') }><a className={ `cursor-pointer nav-link ${this.state.sel_nev === 'parcelPointFactors' ? "active" : ""}` } href="#parcelPointFactors" >Factores de pontuação</a></li>
                        <li onClick={ () => this.updatesel_nev('parcelSettlementCharacteristics') }><a className={ `cursor-pointer nav-link ${this.state.sel_nev === 'parcelSettlementCharacteristics' ? "active" : ""}` } href="#parcelSettlementCharacteristics" >Características do povoamento</a></li>
                        <li>
                            <ul className="list-unstyled">
                                <li onClick={ () => this.updatesel_nev('parcelPopulationDetails') }><a className={ `cursor-pointer nav-link ${this.state.sel_nev === 'parcelPopulationDetails' ? "active" : ""}` } href="#parcelPopulationDetails" >Detalhes do povoamento</a></li>
                                <li onClick={ () => this.updatesel_nev('Castas') } ><a className={ `cursor-pointer nav-link ${this.state.sel_nev === 'Castas' ? "active" : ""}` } href="#Castas" >Castas</a></li>
                            </ul>
                        </li>
                        <li onClick={ () => this.updatesel_nev('matrixArticle') }><a className={ `cursor-pointer nav-link ${this.state.sel_nev === 'matrixArticle' ? "active" : ""}` } href="#matrixArticle">Artigo Matricial</a></li>
                        <li onClick={ () => this.updatesel_nev('Enquadramento') }><a className={ `cursor-pointer nav-link ${this.state.sel_nev === 'Enquadramento' ? "active" : ""}` } href="#Enquadramento">Enquadramento legal</a></li>
                        <li onClick={ () => this.updatesel_nev('Registo') }><a className={ `cursor-pointer nav-link ${this.state.sel_nev === 'Registo' ? "active" : ""} ` } href="#Registo">Registo de alterações</a></li>
                    </ul>

                } 
                {
                    this.props.type === "Boletims" &&
                    <ul className="list-unstyled">
                        <li onClick={() => this.updatesel_nev('parcel')} > <a className={ `cursor-pointer nav-link ${this.state.sel_nev === 'parcel' ? "active" : ""}` } href="#parcel" >Boletim</a></li>
                        <li  onClick={() => this.updatesel_nev('parcelPointFactors')} > <a  className={ `cursor-pointer nav-link ${this.state.sel_nev === 'parcelPointFactors' ? "active" : ""}` } href="#parcelPointFactors"  >Factores de Pontuação</a></li>
                        <li>
                            <ul className="list-unstyled">
                                <li className={this.state.sel_nev == 'Abrigo' ? "active selectedParcelform" : ""} onClick={() => this.updatesel_nev('Abrigo')}><a  className={ `cursor-pointer nav-link ${this.state.sel_nev === 'Abrigo' ? "active" : ""}` } href="#Abrigo" >Abrigo</a></li>
                                <li className={this.state.sel_nev == 'Natureza_do_Terreno' ? "active selectedParcelform" : ""} onClick={() => this.updatesel_nev('Natureza_do_Terreno')} ><a className={ `cursor-pointer nav-link ${this.state.sel_nev === 'Natureza_do_Terreno' ? "active" : ""}` } href="#Natureza_do_Terreno" >Natureza do Terreno</a></li>
                                <li className={this.state.sel_nev == 'Pedregosidade' ? "active selectedParcelform" : ""} onClick={() => this.updatesel_nev('Pedregosidade')} ><a className={ `cursor-pointer nav-link ${this.state.sel_nev === 'Pedregosidade' ? "active" : ""}` } href="#Pedregosidade" >Pedregosidade</a></li>
                                <li className={this.state.sel_nev == 'Compasso_Plantação' ? "active selectedParcelform" : ""} onClick={() => this.updatesel_nev('Compasso_Plantação')} ><a className={ `cursor-pointer nav-link ${this.state.sel_nev === 'Compasso_Plantação' ? "active" : ""}` } href="#Compasso_Plantação" >Compasso Plantação</a></li>
                                <li className={this.state.sel_nev == 'Modo_Condução' ? "active selectedParcelform" : ""} onClick={() => this.updatesel_nev('Modo_Condução')} ><a className={ `cursor-pointer nav-link ${this.state.sel_nev === 'Modo_Condução' ? "active" : ""}` } href="#Modo_Condução" >Modo Condução</a></li>
                                <li className={this.state.sel_nev == 'Porta_Enxertos' ? "active selectedParcelform" : ""} onClick={() => this.updatesel_nev('Porta_Enxertos')} ><a className={ `cursor-pointer nav-link ${this.state.sel_nev === 'Porta_Enxertos' ? "active" : ""}` } href="#Porta_Enxertos" >Porta-Enxertos</a></li>
                            </ul>
                        </li>
                        <li  onClick={() => this.updatesel_nev('parcelSettlementCharacteristics')} >
                            <a className={ `cursor-pointer nav-link ${this.state.sel_nev === 'parcelSettlementCharacteristics' ? "active" : ""}` } href="#parcelSettlementCharacteristics" >Características do povoamento</a></li>
                        <li> 
                            <ul className="list-unstyled">
                                <li className={this.state.sel_nev == 'parcelPopulationDetails' ? "active selectedParcelform" : ""} onClick={() => this.updatesel_nev('parcelPopulationDetails')}><a className={ `cursor-pointer nav-link ${this.state.sel_nev === 'parcelPopulationDetails' ? "active" : ""}` } href="#parcelPopulationDetails" >Detalhes do povoamento</a></li>
                                <li className={this.state.sel_nev == 'Castas' ? "active selectedParcelform" : ""} onClick={() => this.updatesel_nev('Castas')} ><a className={ `cursor-pointer nav-link ${this.state.sel_nev === 'Castas' ? "active" : ""}` } href="#Castas" >Castas</a></li>
                            </ul>
                        </li>
                        <li className={this.state.sel_nev == 'matrixArticle' ? "active selectedParcelform" : ""} onClick={() => this.updatesel_nev('matrixArticle')}><a className={ `cursor-pointer nav-link ${this.state.sel_nev === 'matrixArticle' ? "active" : ""}` } href="#matrixArticle" >Artigo Matricial</a></li>
                        <li className={this.state.sel_nev == 'Assinaturas' ? "active selectedParcelform" : ""} onClick={() => this.updatesel_nev('Assinaturas')}><a  className={ `cursor-pointer nav-link ${this.state.sel_nev === 'Assinaturas' ? "active" : ""}` } href="#Assinaturas">Assinaturas</a></li>
                    </ul>
                }
                {
                    this.props.type === "instalaçõesinsert" &&
                    <ul className="list-unstyled">
                        {
                            this.state.instalaçõesinsert.map((row,index) => (
                                <li key={index} onClick={ () => this.updatesel_nev(row) }> <a className={ `cursor-pointer nav-link ${this.state.sel_nev === row ? "active" : ""}` } href={ `#${row}` } > { Lang.langCheck.langRequest(row) }</a></li>
                            ))
                        }
                    </ul>
                }




            </div>
        )
    }
}

export default WizardLeft;